export const TODAY = new Date();

// Default range used by strategy-list callers (StrategiesList's own fetch
// and FundManagerDashboard's shared prefetch) so both build the exact same
// "this month" query string without duplicating the calculation.
export const getCurrentMonthFilter = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");

  const startDate = `${year}-${month}-01`;

  const lastDay = new Date(year, now.getMonth() + 1, 0).getDate();
  const endDate = `${year}-${month}-${String(lastDay).padStart(2, "0")}`;

  return `startDate=${startDate}&endDate=${endDate}`;
};

export const toISOString = (date = TODAY) => {
  return (
    [
      date.getFullYear(),
      (date.getMonth() + 1).toString().padStart(2, "0"),
      date.getDate().toString().padStart(2, "0"),
    ].join("-") +
    "T" +
    [
      date.getHours().toString().padStart(2, "0"),
      date.getMinutes().toString().padStart(2, "0"),
      date.getMinutes().toString().padStart(2, "0"),
    ].join(":")
  );
};

export const addHours = (numOfHours, date = new Date()) => {
  const rDate = new Date();
  rDate.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
  return rDate;
};

export const getISOHours = (date) => {
  return toISOString(date).split("T")[1].substring(0, 5);
};

export const parseObjectDate = (date, format = 1) => {
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const weekDay = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let r;
  switch (format) {
    case 1: // DD/MM/YYYY
      r = [
        date.getDate().toString().padStart(2, "0"),
        (date.getMonth() + 1).toString().padStart(2, "0"),
        date.getFullYear(),
      ].join("/");
      break;
    case 2: // Dia Mes YY
      r = [
        date.getDate().toString().padStart(2, "0"),
        meses[date.getMonth()],
        date.getFullYear().toString().substring(2, 4) + "'",
      ].join(" ");
      break;

    case 3: // DD/MM/YYYY, hh:mm A
      r =
        [
          date.getDate().toString().padStart(2, "0"),
          (date.getMonth() + 1).toString().padStart(2, "0"),
          date.getFullYear(),
        ].join("/") +
        ", " +
        date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
      break;
    case 4: // YYYY-MM-DD
      r = [
        date.getFullYear(),
        (date.getMonth() + 1).toString().padStart(2, "0"),
        date.getDate().toString().padStart(2, "0"),
      ].join("-");
      break;
    case 5: // weekDay, Dia de Mes de YYYY
      r =
        [weekDay[date.getDay()]] +
        ", " +
        [
          date.getDate().toString().padStart(2, "0"),
          meses[date.getMonth()],
          date.getFullYear(),
        ].join(" de ");
      break;
    default:
  }
  return r;
};
